module.exports = __webpack_public_path__ + "41c993ec047178c0b86dfcf586b24e28.png";